import React from "react";
import { useState, useEffect } from "react";
import { subscribePending } from "../hooks/useFetch";
// Import components
import AsideMenu from "../components/AsideMenu";
import HeaderHomePage from "../components/HeaderHomePage";
import HeaderMobile from "../components/HeaderMobile";
import Preloader from "../components/Preloader";
import Footer from "../components/Footer";
import WeSection from "../components/WeSection";
import CasesSection from "../components/CasesSection";
import WorkSection from "../components/WorkSection";
import ExpertiseSection from "../components/ExpertiseSection";
import WhenSection from "../components/WhenSection";
import TeamSection from "../components/TeamSection";
import PartnersSection from "../components/PartnersSection";
import StaSection from "../components/StaSection";
import ModalForm from "../components/ModalForm";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";

export default function Homepage() {
    const [modalShow, setModalShow] = useState(false);

    // Прелоадер держим, пока грузятся данные секций, и снимаем только когда
    // все запросы завершились (счётчик из useFetch дошёл до 0) — тогда
    // страница появляется целиком, без подскока WorkSection. Контент при этом
    // всегда смонтирован под оверлеем, чтобы анимация WorkSection корректно
    // замерила раскладку.
    const [ready, setReady] = useState(false);

    useEffect(() => {
        let revealed = false;
        let raf = 0;
        const reveal = () => {
            if (revealed) return;
            revealed = true;
            setReady(true);
        };

        const unsubscribe = subscribePending((count) => {
            if (count === 0) {
                // ждём кадр, чтобы React успел отрисовать секции с данными,
                // прежде чем убрать прелоадер
                cancelAnimationFrame(raf);
                raf = requestAnimationFrame(() =>
                    requestAnimationFrame(reveal)
                );
            }
        });

        // страховка: даже если какой-то запрос завис — не держим прелоадер
        // дольше 8 секунд
        const fallback = setTimeout(reveal, 8000);

        return () => {
            unsubscribe();
            clearTimeout(fallback);
            cancelAnimationFrame(raf);
        };
    }, []);

    return (
        <div>
            {!ready && <Preloader />}
            <HeaderMobile onOpen={setModalShow} />
            <Swiper
                className="fullpage-swiper swiper"
                enabled={false}
                direction={"vertical"}
                slidesPerView={1}
                spaceBetween={0}
            >
                <div slot="container-start">
                    <AsideMenu />
                </div>

                <SwiperSlide>
                    <div className="fullpage-swiper__slide">
                        <HeaderHomePage onOpen={setModalShow} />
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="fullpage-swiper__slide">
                        <WeSection />
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="fullpage-swiper__slide">
                        <CasesSection />
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="fullpage-swiper__slide">
                        <WorkSection />
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="fullpage-swiper__slide">
                        <ExpertiseSection />
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="fullpage-swiper__slide">
                        <WhenSection />
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="fullpage-swiper__slide">
                        <TeamSection />
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="fullpage-swiper__slide">
                        <PartnersSection />
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="fullpage-swiper__slide">
                        <StaSection onOpen={setModalShow} />
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="fullpage-swiper__slide">
                        <Footer />
                    </div>
                </SwiperSlide>
            </Swiper>
            <ModalForm show={modalShow} onHide={setModalShow} />
        </div>
    );
}
